import { render, staticRenderFns } from "./locations.vue?vue&type=template&id=04d766c6&scoped=true"
import script from "./locations.vue?vue&type=script&lang=js"
export * from "./locations.vue?vue&type=script&lang=js"
import style0 from "./locations.vue?vue&type=style&index=0&id=04d766c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d766c6",
  null
  
)

export default component.exports